"use client";
import { jsxs as C, Fragment as o, jsx as r } from "react/jsx-runtime";
import { createSvgIcon as t } from "@mui/material/utils";
const c = t(
  /* @__PURE__ */ C(o, { children: [
    /* @__PURE__ */ r(
      "path",
      {
        d: "M11.9991 17.61C12.5513 17.61 12.9991 17.1623 12.9991 16.61C12.9991 16.0578 12.5513 15.61 11.9991 15.61C11.4468 15.61 10.9991 16.0578 10.9991 16.61C10.9991 17.1623 11.4468 17.61 11.9991 17.61Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ r(
      "path",
      {
        d: "M10.9491 7.40004L11.2891 13.5C11.3391 14.38 12.6591 14.38 12.7091 13.5L13.0491 7.40004C13.0491 7.40004 13.0491 7.32004 13.0491 7.28004C12.9491 5.90004 10.8891 6.01004 10.9391 7.40004H10.9491Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ r(
      "path",
      {
        d: "M11.9991 1.29004C6.08906 1.29004 1.28906 6.09004 1.28906 12C1.28906 17.91 6.08906 22.71 11.9991 22.71C17.9091 22.71 22.7091 17.91 22.7091 12C22.7091 6.09004 17.9091 1.29004 11.9991 1.29004ZM11.9991 21.29C6.87906 21.29 2.70906 17.12 2.70906 12C2.70906 6.88004 6.87906 2.71004 11.9991 2.71004C17.1191 2.71004 21.2891 6.88004 21.2891 12C21.2891 17.12 17.1191 21.29 11.9991 21.29Z",
        fill: "currentColor"
      }
    )
  ] }),
  "KmxErrorStroked"
);
export {
  c as default
};
